import useStyleUtils from "../../../utilities/styles";
import IFolderFormProps from "../IFolderFormProps";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-grid-system";
import TextField from "../../../components/formFields/textField/TextField";
import ImageField from "../../../components/formFields/imageField/ImageField";
import TextArea from "../../../components/formFields/textArea/TextArea";

export default function DetailsTab(props: IFolderFormProps) {
    const { t } = useTranslation();

    const style = useStyleUtils();

    return (
        <Row>
            <Col>
                <Row className={style.mb3}>
                    <Col>
                        <TextField required
                            type='text'
                            label={t("folders.form.fields.name.label")}
                            value={props.data.name}
                            onChange={(value) => props.onChange('name', value)}
                            placeholder={t("folders.form.fields.name.placeholder")}
                            />
                    </Col>
                </Row>
                <Row className={style.mb3}>
                    <Col>
                        <TextField
                            type='text'
                            label={t("folders.form.fields.subtitle.label")}
                            value={props.data.subtitle}
                            onChange={(value) => props.onChange('subtitle', value)}
                            placeholder={t("folders.form.fields.subtitle.placeholder")}
                            />
                    </Col>
                </Row>
                <Row className={style.mb3}>
                    <Col>
                        <TextField
                            type='url'
                            label={t("folders.form.fields.link.label")}
                            value={props.data.url}
                            onChange={(value) => props.onChange('url', value)}
                            placeholder={t("folders.form.fields.link.placeholder")}
                            />
                    </Col>
                </Row>
                <Row className={style.mb3}>
                    <Col>
                        <TextArea
                            label={t("folders.form.fields.notes.label")}
                            value={props.data.notes}
                            onChange={(value) => props.onChange('notes', value)}
                            placeholder={t("folders.form.fields.notes.placeholder")}
                            />
                    </Col>
                </Row>
                <Row className={style.mb3}>
                    <Col xs={12} md={6}>
                        <span className={style.dBlock}>
                            {t("folders.form.fields.image.label")}
                        </span>
                        <ImageField disabled={false} image={props.image} onImageChange={props.onImageChange} />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}